<template>
	<div class="flex flex-col gap-4 justify-between items-center flex-1">
		<div class="p-2 pb-0 lg:container">
			<div v-if="clientInfo" class="flex flex-col gap-4">
				<div class="flex justify-between items-center">
					<img src="../../assets/icons/journey-green-logo.svg" alt="Journey Logo" class="w-24 h-14" />
					<div class="flex flex-col">
						<span class="text-journey-black uppercase text-lg font-medium font-lato mb-0.5"
							>Seu perfil de saúde Journey</span
						>
					</div>
				</div>
				<div
					class="
						grid
						grid-rows-[1fr_auto_1fr]
						lg:grid-rows-none lg:grid-cols-2
						gap-7
						custom-shadow
						rounded-md
						border-t-2
						p-6
						border-journey-blue
					"
				>
					<div class="flex gap-5 items-center">
						<div
							class="
								text-white
								bg-journey-blue
								p-2
								w-20
								h-20
								rounded-full
								font-bold
								text-4xl
								flex
								justify-center
								items-center
							"
						>
							{{ nameInitials }}
						</div>
						<div class="flex flex-col text-journey-black">
							<span class="text-black font-semibold pb-0.5">{{ name }}</span>
							<span
								>{{ age }} anos<span v-if="treatmentForm">, {{ treatmentForm }}</span></span
							>
							<span>{{ clientInfo.address }}</span>
							<span>{{ clientInfo.phoneNumber }}</span>
						</div>
					</div>
					<div class="flex justify-center items-center lg:hidden">
						<div class="h-1 w-full bg-journey-light-white"></div>
					</div>
					<div class="flex flex-col gap-0.5 text-journey-gray rounded-lg lg:pl-4">
						<p class="text-black pl-0.5 primary-title border-journey-light-blue">Plano de Saúde</p>
						<div v-for="item in insurerPlanData" :key="item.label" class="grid grid-cols-2 pl-1">
							<span class="text-black font-semibold">{{ item.label }}</span>
							<span class="text-black">{{ item.value }}</span>
						</div>
					</div>
				</div>
				<div class="grid grid-rows-4 lg:grid-rows-none lg:grid-cols-4 gap-4">
					<div
						v-for="item in principalData"
						@click="expandData(item.label)"
						:key="item.label"
						:class="['p-6 bg-journey-light-white rounded-lg text-left', item.value.length > 3 && 'cursor-pointer']"
					>
						<div class="flex flex-col text-journey-gray rounded-lg h-full items-start">
							<p class="text-black primary-title border-journey-light-blue text-xl">{{ item.label }}</p>
							<div class="flex flex-col gap-1 pl-1 w-full">
								<span
									v-for="value in item.isExpanded ? item.value : item.value.slice(0, 3)"
									:key="value.id"
									class="text-journey-black"
									>{{ value.text }}</span
								>
								<div v-if="item.value.length > 3" class="flex justify-center">
									<img v-if="item.isExpanded" src="../../assets/icons/arrow-up.svg" />
									<img v-else src="../../assets/icons/arrow-down.svg" />
								</div>
							</div>
						</div>
					</div>
					<div class="p-6 bg-journey-light-white flex justify-between rounded-lg">
						<div class="flex flex-col justify-start">
							<p class="text-black pl-0.5 primary-title border-journey-light-blue h-10 inline-block">Motivação</p>
							<p v-if="motivation !== ''" class="text-black pl-1">{{ motivation }}</p>
							<p v-else class="text-black pl-1">Não avaliado</p>
						</div>
						<div :class="motivationColor + ' rounded-full h-12 w-12'"></div>
					</div>
				</div>
				<div
					@click="expandData('Linha de cuidado personalizada')"
					:class="[
						'p-6 bg-journey-light-white rounded-lg custom-shadow text-left',
						clientInfo.solutions.length > 3 && 'cursor-pointer',
					]"
				>
					<p class="text-black pl-0.5 primary-title border-journey-light-blue">Linha de cuidado personalizada</p>
					<div
						class="
							flex flex-col
							lg:grid lg:grid-cols-2
							gap-1
							lg:gap-x-1 lg:gap-y-0
							text-journey-gray
							rounded-lg
							pl-1
							lg:pl-0
						"
					>
						<div v-for="item in personalizedHealthPlan" :key="item.id" class="flex flex-col lg:grid lg:grid-cols-2">
							<span class="text-black font-semibold">{{ item.text }}</span>
							<div
								:class="[
									'flex gap-1 lg:gap-2 items-center lg:justify-end mr-4 font-bold',
									personalizedHealthPlanStatusColor(item.status).text,
								]"
							>
								<span class="text-right">{{ item.statusTranslated }}</span>
								<div v-if="item.status === 'COMPLETED' && item.ratingValue && item.ratingValue <= 3">
									<img
										:key="1"
										class="w-4 h-4"
										:src="require(`../../assets/icons/rating-icon-${item.ratingValue}.svg`)"
										alt=""
									/>
								</div>
								<div v-else-if="item.status === 'COMPLETED'" class="flex gap-x-1">
									<span class="text-journey-blue font-bold inline-block align-middle">{{
										formatNumber(item.ratingValue)
									}}</span>
									<img class="w-5" src="../../assets/icons/star-green.svg" alt="" />
								</div>
								<div v-else-if="item.status === 'CONFIRMED'" class="flex gap-x-1">
									<feather-icon size="14" icon="AlertCircleIcon" />
								</div>
								<div v-else-if="item.status === 'FAILED'" class="flex items-center relative">
									<img class="w-5" :src="require('../../assets/icons/alert.svg')" alt="" />
								</div>
							</div>
						</div>
					</div>
					<div v-if="clientInfo.solutions.length > 3" class="flex justify-center pt-2">
						<img v-if="isExpanded['Linha de cuidado personalizada']" src="../../assets/icons/arrow-up.svg" />
						<img v-else src="../../assets/icons/arrow-down.svg" />
					</div>
				</div>
			</div>
		</div>
		<div class="flex justify-center items-center py-6 bg-journey-blue w-full">
			<img src="../../assets/icons/Journey.svg" />
		</div>
	</div>
</template>

<script>
	import { Component, Prop, Vue } from "vue-property-decorator";
	import CustomInput from "@/layouts/components/Input.vue";
	import CustomButton from "@/layouts/components/Button.vue";
	import GuideBalloon from "@/layouts/components/GuideBalloon.vue";
	import PasswordRecoveryModal from "@/layouts/components/PasswordRecoveryModal.vue";
	import InitialsBadge from "@/layouts/components/InitialsBadge.vue";
	import { ClientMotivation } from "@/interfaces/client";
	import { translateClientMotivation } from "@/interfaces/user";
	import { AppointmentStatus } from "@/interfaces/appointment";
	import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";

	@Component({
		components: {
			"custom-button": CustomButton,
			"custom-input": CustomInput,
			"password-recovery-modal": PasswordRecoveryModal,
			GuideBalloon,
			"initials-badge": InitialsBadge,
			FeatherIcon,
		},
	})
	export default class ClientGoals extends Vue {
		@Prop({ default: null }) clientInfo;
		isExpanded = {
			Necessidades: false,
			"Riscos de saúde": false,
			Diagnósticos: false,
			"Linha de cuidado personalizada": false,
		};

		get name() {
			return this?.clientInfo?.name || "";
		}

		get age() {
			const birthDate = new Date(this.clientInfo.birthDate);
			const todayDate = new Date();

			return todayDate.getFullYear() - birthDate.getFullYear();
		}

		get treatmentForm() {
			return this.clientInfo.treatmentForm;
		}

		get insurerPlanData() {
			return [
				{
					label: this.clientInfo.insurerPlan?.corporateClient,
					value: this.clientInfo.insurerPlan?.name,
				},
				{
					label: "Carteirinha",
					value: this.clientInfo.insurerPlan?.insurerNumber,
				},
				{
					label: "Início no Programa",
					value: this.firstDayDate,
				},
				{
					label: "Última interação",
					value: this.lastDayDate,
				},
			];
		}

		get principalData() {
			return [
				{
					label: "Necessidades",
					value: this.clientInfo.needs,
					isExpanded: this.isExpanded.Necessidades,
				},
				{ label: "Riscos de saúde", value: this.clientInfo.tags, isExpanded: this.isExpanded["Riscos de saúde"] },
				{ label: "Diagnósticos", value: this.clientInfo.diseases, isExpanded: this.isExpanded.Diagnósticos },
			];
		}

		translateSolutionStatus(status) {
			const solutionStatusTranslated = {
				[AppointmentStatus.COMPLETED]: "Realizado",
				[AppointmentStatus.FAILED]: "Não realizado",
				[AppointmentStatus.CONFIRMED]: "Pendente",
			};

			return solutionStatusTranslated[status] || "";
		}

		get personalizedHealthPlan() {
			return this.solutions.map(solution => {
				if (
					["Orientações", "Sem necessidade"].includes(solution.solutionCategoryName) &&
					solution.status === "CONFIRMED"
				) {
					return { ...solution, status: AppointmentStatus.CONFIRMED, statusTranslated: "Pendente" };
					guideClientReview?.props.appointments.push(solution);
				} else if (solution.status === "CONFIRMED") {
					return { ...solution, status: AppointmentStatus.CONFIRMED, statusTranslated: "Pendente" };
					guidePlanAction?.props.appointments.push(solution);
				} else if (solution.status !== "PRE_SELECTED") {
					return { ...solution, statusTranslated: this.translateSolutionStatus(solution.status) };
					guideAppointmentsHistory?.props.appointments.push(solution);
				}
			});

			return this.solutions.map(solution => ({
				...solution,
				statusTranslated: translateSolutionStatus(solution.status),
			}));
		}

		get motivation() {
			return translateClientMotivation(this.clientInfo.motivation);
		}

		get motivationColor() {
			const motivationColors = {
				[ClientMotivation.PROACTIVE]: "bg-journey-green",
				[ClientMotivation.AMBIVALENT]: "bg-journey-yellow",
				[ClientMotivation.RESISTANT]: "bg-journey-red",
			};

			return motivationColors[this.clientInfo.motivation];
		}

		personalizedHealthPlanStatusColor(solutionStatus) {
			const personalizedHealthPlanColors = {
				[AppointmentStatus.COMPLETED]: { bg: "bg-journey-green", text: "text-journey-green" },
				[AppointmentStatus.CONFIRMED]: { bg: "bg-journey-yellow", text: "text-journey-dark-yellow" },
				[AppointmentStatus.FAILED]: { bg: "bg-journey-red", text: "text-journey-red" },
			};

			return personalizedHealthPlanColors[solutionStatus] || { bg: "", text: "" };
		}

		get firstDayDate() {
			return new Date(this.clientInfo.firstDayDate).toLocaleDateString("pt-BR");
		}

		get lastDayDate() {
			return new Date(this.clientInfo.lastDayDate).toLocaleDateString("pt-BR");
		}

		get solutions() {
			return this.isExpanded["Linha de cuidado personalizada"]
				? this.clientInfo.solutions
				: this.clientInfo.solutions.slice(0, 3);
		}

		expandData(label) {
			this.isExpanded[label] = !this.isExpanded[label];
		}

		get nameInitials() {
			const names = this.name.split(" ");
			let initials = names[0].substring(0, 1).toUpperCase();

			if (names.length > 1) {
				initials += names[names.length - 1].substring(0, 1).toUpperCase();
			}
			return initials;
		}

		formatNumber(number) {
			if (number) {
				return number.toFixed(1);
			} else {
				return "-";
			}
		}
	}
</script>

<style lang="scss">
	.primary-title {
		@apply font-bold text-xl text-journey-black border-l-4 pl-0.5 font-roboto-slab;
	}

	.custom-shadow {
		box-shadow: 0px 36px 120px -56px #00000040;
	}
</style>
